<style scoped>
header p {
  font-size: 20px;
  margin: 0px;
}

header .title {
  font-size: 4em;
  font-weight: bold;
  text-transform: uppercase;
}

.link-text {
  font-size: 15pt;
}
</style>

<template>
  <div>
    <header class="spaced-header bg-light">
      <b-row>
        <b-col class="mb-2">
          <h1 class="text-center title">{{headerData.title}}</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
            <p class="headline" v-html="headerData.headline"></p>
            <p v-if="headerData.link">
              <small>{{headerData.link.prevText}}
                <router-link :to="{name: headerData.link.routeName}" class="text-light-blue">
                  <strong class="link-text">{{headerData.link.text}}</strong>
                </router-link>
              </small>
            </p>
        </b-col>
      </b-row>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    headerData: Object,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/BasicHeader.vue